
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { usePromotionItemTranslate } from '@/modules/promotion/item/model/translate';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.ITEM.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, getListSupported, actions, localeSupportedOptions } = usePromotionItemTranslate();

        onMounted(async () => {
            await getListSupported();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
